import { generatePath, Link, Navigate, useLocation } from 'react-router-dom';
import { tr } from '@repo/locale';
import { PARKING_CODE_REGEX, SPOT_NAME_REGEX } from '@repo/domain-service';

import { PARKING_SLUG_ALIASES } from '@shared/constants/parkingSlugAliases';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

const PATH_REDIRECT_REGEX = new RegExp(
  `^/(${PARKING_CODE_REGEX.source.slice(1, -1)})(?:/(${SPOT_NAME_REGEX.source.slice(1, -1)}))?/?$`
);

const getParkingRedirectPath = (pathname: string): string | null => {
  const aliasTargetSlug = PARKING_SLUG_ALIASES.get(pathname.slice(1));
  if (aliasTargetSlug) return generatePath(ROUTE_PATHS[RouteName.PARKING_LANDING], { slug: aliasTargetSlug });

  const match = pathname.match(PATH_REDIRECT_REGEX);
  if (!match) return null;

  const [, slug, spotName] = match;
  return spotName
    ? generatePath(ROUTE_PATHS[RouteName.PARKING_LANDING_WITH_SPOT], { slug, spotName })
    : generatePath(ROUTE_PATHS[RouteName.PARKING_LANDING], { slug });
};

export default function NotFoundPage() {
  const { pathname } = useLocation();
  const redirectPath = getParkingRedirectPath(pathname);

  if (redirectPath) {
    return <Navigate to={redirectPath} replace />;
  }

  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <h1 className="text-park-blue-9 text-3xl font-bold">{tr('not_found.title')}</h1>
        <p className="text-base">{tr('not_found.description')}</p>
        <Link to={ROUTE_PATHS[RouteName.HOME]} className="text-park-blue-7 hover:text-park-blue-9 underline">
          {tr('not_found.back_home')}
        </Link>
      </div>
    </div>
  );
}
